<template>
  <div>
    <v-dialog
      v-model="showModal"
      ref="ModalQRUser"
      hide-header
      hide-footer
      centered
      @hidden="hide"
      scroll-strategy="none"
    >
      <div class="h-100 overflow-y-auto">
        <div>
          <template v-if="$store.state.theme.display_profile_complete == '1'">
            <div class="progress-bar-circle shadow-sm" id="circle-progress-2">
              <div
                v-if="userProfile.pictureUrl"
                class="profile-img"
                v-bind:style="{
                  backgroundImage: 'url(' + userProfile.pictureUrl + ')'
                }"
              ></div>
              <div
                v-else-if="profile.picture"
                class="profile-img"
                v-bind:style="{
                  backgroundImage: 'url(' + profile.picture + ')'
                }"
              ></div>
              <div
                v-else
                class="profile-img"
                v-bind:style="{
                  backgroundImage: 'url(' + pictureProfile + ')'
                }"
              ></div>
            </div>
            <div
              class="box shadow-sm"
              v-if="$store.state.completeProfile.profile != 100"
              @click="$router.push('/edit-profile-required')"
            >
              <div class="point-box">
                {{ Math.round($store.state.completeProfile.profile) }}%
              </div>
              <div>
                <span class="f-bold">
                  <span data-lang="complate_profile">
                    {{ $t("complate_profile") }}
                  </span>
                  :
                  {{ Math.round($store.state.completeProfile.profile) }}%</span
                >
                <br />
                {{ $store.state.theme.profile_complete_description }}
              </div>
            </div>
          </template>
          <template v-else>
            <div
              v-if="userProfile.pictureUrl"
              class="profile-img-2"
              v-bind:style="{
                backgroundImage: 'url(' + userProfile.pictureUrl + ')'
              }"
            ></div>
            <div
              v-else-if="profile.picture"
              class="profile-img-2"
              v-bind:style="{
                backgroundImage: 'url(' + profile.picture + ')'
              }"
            ></div>
            <div
              v-else
              class="profile-img-2"
              v-bind:style="{
                backgroundImage: 'url(' + pictureProfile + ')'
              }"
            ></div>
          </template>
          <div class="text-center">
            <div class="f-bold f-xl">
              {{ profile.first_name_th }} {{ profile.last_name_th }}
            </div>
          </div>
          <div class="f-md text-center">
            <span class="pl-2 profile-ft-color">{{ profile.member_id }}</span>
          </div>

          <div class="text-center">
            <qrcode-vue
              class="qr-width-70"
              :value="
                qrType == 'Telephone' ? profile.telephone : profile.member_id
              "
              render-as="svg"
              background="transparent"
            />
          </div>
          <div class="timer-countdown" v-if="displayCountdown">
            <div data-lang="qr_count_time">{{ $t("qr_count_time") }}</div>
            <div>
              {{ countTime }}
            </div>
          </div>
        </div>
        <c-btn block variant="confirm-primary" @click="hide">
          {{ $t("close_window") }}
        </c-btn>
      </div>
    </v-dialog>
  </div>
</template>

<script>
import picture from "@/assets/images/default-image.png";

var x;
export default {
  props: {
    profile: {
      required: true,
      type: Object
    },
    userProfile: {
      required: false,
      type: Object
    }
  },

  mounted() {},
  data() {
    return {
      showModal: false,
      pictureProfile: picture,
      countTime: "00:00",
      displayCountdown:
        this.$store.state.theme.line_display_code_countdown == "1"
          ? true
          : false,
      qrType: this.$store.state.theme.qr_code
    };
  },
  methods: {
    show() {
      this.showModal = true;
      this.countTimer();

      // setTimeout(() => {
      this.$nextTick(() => {
        if (this.$store.state.theme.display_profile_complete == "1") {
          let bodyStyles = document.body.style;
          bodyStyles.setProperty(
            "--count-progress-2",
            Math.round(this.$store.state.completeProfile.profile)
          );
          document
            .getElementById("circle-progress-2")
            .setAttribute(
              "count",
              Math.round(this.$store.state.completeProfile.profile)
            );
          document.getElementById("circle-progress-2").style.display = "block";
        }
      });
      // }, 200);
    },
    hide() {
      this.showModal = false;
      clearInterval(x);
    },

    countTimer() {
      function padZero(value) {
        value = String(value);
        return value.length == 1 ? "0" + value : value;
      }
      var countDownDate = this.$moment().add(10, "minutes").valueOf();
      x = setInterval(() => {
        var now = this.$moment().valueOf();
        var distance = countDownDate - now;
        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = padZero(
          Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
        );
        var minutes = padZero(
          Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
        );
        var seconds = padZero(Math.floor((distance % (1000 * 60)) / 1000));

        if (distance < 0) {
          return clearInterval(x);
          // this.countTime = "EXPIRED";
        }
        this.$nextTick(() => {
          this.countTime = minutes + " : " + seconds;
        });
      }, 900);
    },
    dateFormat(value, format) {
      if (!value) return "-";
      if (!format) format = "DD-MM-YYYY";
      return this.$moment(value).format(format);
    }
    // convertTelePhone(val) {
    //   if (!val) return null;

    //   return `${val.substring(0, 3)}-${val.substring(3, 6)}-${val.substring(
    //     6,
    //     10
    //   )}`;
    // }
  }
};
</script>

<style lang="scss" scoped>
@import "scss";
.profile-img-2 {
  width: 150px;
  height: 150px;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border: 1px solid black;
  border-radius: 50%;
  margin: 1rem auto;
}
</style>
